<template>
  <div>
    <div>
      <!--      <div class="login"><img src="../../static/images/back.png"></div>-->
      <el-form
        :model="formData"
        status-icon
        :rules="rules"
        ref="formData"
        class="login-wrap"
      >
        <el-form-item prop="user_email">
          <el-input
            type="text"
            v-model="formData.user_email"
            placeholder="user email"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <!--<el-form-item prop="user_password">
          <el-input type="password" v-model="formData.user_password" placeholder="password" autocomplete="off" ></el-input>
        </el-form-item>-->
        <el-form-item style="margin-bottom: 0">
          <!--<a style="float: left;color: black" @click="gotoForget()"><small>forget password</small></a>-->
          <el-button
            style="float: right"
            type="default"
            class="btn-primary"
            @click="submitForm('formData')"
            >logIn</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!--<el-dialog title="Reset Password" :visible.sync="dialogVisible" :fullscreen="false" width="400px" top="10vh"
               :destroy-on-close="true" :show-close="true" :close-on-click-modal="false" :close-on-press-escape="false">
      <reset v-if="dialogVisible" @close="dialogVisible=false"></reset>
    </el-dialog>-->
  </div>
</template>
<style scoped>
.login {
  width: 580px;
  position: fixed;
  left: 50%;
  margin-left: -280px;
  top: 15%;
}
.login-wrap {
  width: 340px;
  position: fixed;
  left: 50%;
  margin-left: -170px;
  top: 30%;
  padding: 20px;
  border-radius: 10px;
  background: -moz-linear-gradient(left top, deepskyblue, lightblue);
  background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    color-stop(0, deepskyblue),
    color-stop(1, lightblue)
  );
}
</style>

<script>
import reset from "./ResetPassword";
export default {
  components: {
    reset,
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        user_email: "",
        //user_password: "",
      },
      rules: {
        user_email: [
          {
            required: true,
            message: "please enter user email!",
            trigger: "blur",
          },
        ],
        //user_password: [{ required: true, message: 'please enter password!', trigger: 'blur'}],
      },
    };
  },
  created() {},
  mounted() {
    this.$emit("outLogin", {});
  },
  methods: {
    /*gotoForget(){
          this.dialogVisible=true
      },*/
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.rootV1.post(
            "/web/user/adminlogin/link",
            this.formData,
            (res) => {
              this.$alert(
                "Please go to your email and login through the link we sent you!",
                "info",
                {
                  confirmButtonText: "confirm",
                  type: "success",
                  callback: (action) => {},
                }
              );
            },
            (res) => {
              console.log("res2:", res);
              this.$message.error(res.errmsg);
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue